import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import debounce from "lodash/debounce"; // Import debounce
import "./Products.css";

const BASE_URL =
  process.env.NODE_ENV === "development"
    ? "http://127.0.0.1:8000"
    : "https://bonobohope-chazselph.pythonanywhere.com";

const Products = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchProducts = debounce(async () => {
    try {
      const response = await fetch(`${BASE_URL}/api/printify-products/`);
      if (!response.ok) throw new Error("Failed to fetch products");
      const data = await response.json();
      setProducts(data);
      setLoading(false);
    } catch (err) {
      console.error("Fetch products error:", err);
      setError("Unable to load products. Please try again later.");
      setLoading(false);
    }
  }, 1000); // 1-second debounce

  useEffect(() => {
    fetchProducts();
  }, []);

  if (loading)
    return <div className="products-container">Loading products...</div>;
  if (error) return <div className="products-container">Error: {error}</div>;

  return (
    <div className="products-container">
      <h1 className="products-title">Products</h1>
      <ul className="products-list">
        {products.map((product) => {
          const variant =
            product.variants.find((v) => v.is_enabled) || product.variants[0];
          const price = variant ? (variant.price / 100).toFixed(2) : "N/A";

          return (
            <li className="product-item" key={product.id}>
              <Link
                to={`/product/${product.id}`}
                style={{ textDecoration: "none", color: "inherit" }}
              >
                <h2 className="product-title">{product.title}</h2>
                <p className="product-price">${price}</p>
                <img
                  className="product-image"
                  src={product.images[0]?.src}
                  alt={product.title}
                />
              </Link>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default Products;
